import React from "react";
import Layout from "../../components/layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";

export default function ViewWarehouse() {
  const location = useLocation();
  const data = location.state.data;

 const navigate = useNavigate();

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Warehouse</h2>

            
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>


          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Warehouse Name</h6>
                <p className="mt-1">{data.wareHouseName}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">City</h6>
                <p className="mt-1">{data.city}</p>
              </div>
            </div>

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">State</h6>
                <p className="mt-1">{data.state}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Full Address</h6>
                <p className="mt-1">{data.fullAddress}</p>
              </div>
            </div>

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Landmark</h6>
                <p className="mt-1">{data.landMark}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Location Coordinates</h6>
                <p className="mt-1">
                  {data.location.coordinates[0]}, {data.location.coordinates[1]}
                </p>
              </div>
            </div>

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Pincode</h6>
                <p className="mt-1">{data.pincodeId.number}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Pin Type</h6>
                <p className="mt-1">{data.pincodeId.pinType}</p>
              </div>
            </div>

            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Created At</h6>
                <p className="mt-1">{data.createdAt}</p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
